import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=2ebe10a8&scoped=true"
import script from "./QuestionList.vue?vue&type=script&lang=js"
export * from "./QuestionList.vue?vue&type=script&lang=js"
import style0 from "./QuestionList.vue?vue&type=style&index=0&id=2ebe10a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebe10a8",
  null
  
)

export default component.exports